import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const BoxIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Box",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16.45 12.88c-1.93 0-3.7 1.07-4.61 2.77a5.252 5.252 0 0 0-7.76-1.75V9.52c-.08-.57-.61-.98-1.18-.9-.47.07-.84.44-.9.91v8.67c.1 2.9 2.52 5.17 5.42 5.07a5.24 5.24 0 0 0 4.42-2.71 5.243 5.243 0 0 0 7.1 2.19 5.243 5.243 0 0 0 2.19-7.1 5.24 5.24 0 0 0-4.69-2.8m-9.2 8.39a3.15 3.15 0 0 1-3.19-3.1 3.15 3.15 0 0 1 3.1-3.19 3.15 3.15 0 0 1 3.19 3.1v.04c0 1.72-1.38 3.12-3.1 3.14m9.23 0a3.15 3.15 0 0 1-3.19-3.1c-.02-1.74 1.36-3.16 3.1-3.19s3.16 1.36 3.19 3.1v.04c0 1.73-1.39 3.14-3.12 3.14m13.33.36-2.84-3.5 2.84-3.5a1 1 0 0 0-.24-1.45 1.21 1.21 0 0 0-1.58.19l-2.45 3.01-2.44-3a1.21 1.21 0 0 0-1.58-.19 1 1 0 0 0-.29 1.38c.01.02.03.04.04.06l2.84 3.5-2.84 3.5a.987.987 0 0 0 .16 1.39c.02.02.05.04.08.05.5.34 1.17.26 1.58-.19l2.45-3 2.45 2.99c.4.45 1.08.53 1.58.19.46-.29.59-.9.29-1.35-.02-.03-.04-.05-.06-.08"
    })
  }));
};